import SliderManager from "../../js/components/sliderManager";
import CustomSlider from "../../custom-slider/src/customSlider";
import ExternalReview from "../../external-review/src/externalReview";
import DeviceDetector from "../../js/components/deviceDetector";
import ExternalReviewGeneric from "../../external-review/src/externalReviewGeneric";

export default class ListExternalReviews extends HTMLElement {
    constructor() {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.deviceDetector = new DeviceDetector();
        this.customSlider = new CustomSlider();
        this.dataTitle = this.getAttribute('title');
        this.skipRows = parseInt(this.getAttribute('skipRows'));
        this.limitRows = parseInt(this.getAttribute('limitRows'));
        this.endpointReviews = this.getAttribute('endpointReviews');
        this.endpointMethod = this.getAttribute('endpointMethod') || 'POST';
        this.webId = parseInt(this.getAttribute('webId'));
        this.locale = this.getAttribute('locale');
        this.iconScore = this.getAttribute('iconScore');
        this.initialReviews = JSON.parse(this.getAttribute('initialReviews'));
        this.breakpoints = JSON.parse(this.getAttribute('breakpoints'));
        this.isTrustpilot = this.getAttribute('isTrustpilot') !== 'false';
        this.totalSlides = 0;
        this.currentSkip = null;
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#list-external-reviews');
        this.instance = t.content.cloneNode(true);
        this.externalReviewsSliderContainer = this.instance.querySelector('[name="list-external-reviews"]');
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        let titleContainer = this.instance.querySelector('[name="title"]');
        if (this.dataTitle) {
            titleContainer.classList.add('title');
            titleContainer.textContent = this.dataTitle;
        }
        this._shadowRoot.appendChild(this.instance);

        this.externalReviewsSliderContainer.appendChild(this.customSlider.buildSlider(this.createSliderElements(this.initialReviews)));

    }

    initializeSlider(Swiper) {
        this.sliderManager = new SliderManager(Swiper);
        if (!this.externalReviewsSliderContainer) {
            return;
        }

        this.sliderElement = this.sliderManager.addSlider(
            this.externalReviewsSliderContainer,
            {
                slidesPerView: 3,
                navigation: true,
                breakpoints: this.breakpoints
            }
        );

        if (this.initialReviews.length <= 1) {
            this.getReviews();
        }

        this.sliderElement.on('slideChange', () => {
            if (this.sliderElement.activeIndex > (this.sliderElement.slides.length / 2)) {
                if (this.currentSkip === this.skipRows) return;
                this.currentSkip = this.skipRows;
                this.getReviews();
            }
        })
    }

    createSliderElements(dataExternalReviews) {
        const externalReviewsElements = [];

        dataExternalReviews.forEach(data => {
            let externalReview;
            if (this.isTrustpilot) {
                externalReview = new ExternalReview(data, this.iconScore, this.locale);
            } else {
                externalReview = new ExternalReviewGeneric(data, this.iconScore);
            }
            if (data.isTotalReviews && this.deviceDetector.checkScreenBreakpoint('sm')){
                this.externalReviewsSliderContainer.appendChild(externalReview);
            }else{
                externalReviewsElements.push(externalReview);
            }
        });

        return externalReviewsElements;
    }

    setReviews() {
        const totalReviews = this.instance.querySelector('[name="total-reviews"]');
        this.instance.querySelector('[name="review"]').remove();

        this.setScore(totalReviews);
        totalReviews.querySelector('[name="logo"]').src = this.getAttribute('logo');
        totalReviews.querySelector('[name="textScore"]').innerHTML = this.getAttribute('textScore');
    }

    async getReviews() {
        const data = {
            webId: this.webId,
            skip: this.skipRows,
            limit: this.limitRows,
            locale: this.locale
        };
        const reviewsUrl = this.endpointReviews + '?' + new URLSearchParams(data).toString();

        const optionsRequest = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const resReviews = await fetch(reviewsUrl, optionsRequest);
        const dataReviews = await resReviews.json();
        if (dataReviews.code == 200) {
            this.customSlider.addSlideElements(this.createSliderElements(dataReviews.data));
            this.skipRows += dataReviews.data.length;
            this.sliderElement.update();
        }
    }

}
